import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

import { UserRegistration } from '../models/user.registration.interface';
import { ConfigService } from './config.service';
import { BaseService } from "./base.service";

import { Observable } from 'rxjs/Rx';
import { BehaviorSubject } from 'rxjs/Rx';
import decode from 'jwt-decode';


// Add the RxJS Observable operators we need in this app.
import '../../rxjs-operators';
import { User } from 'app/visualis/models/user';
import { Client } from 'app/visualis/models/client';
import { DataService } from 'app/visualis/services/visualis.data.service';

@Injectable()

export class UserService extends BaseService {

  baseUrl: string = '';
  protected handleError(error: any) {

    this.handleErrorBase(error);
    return Observable.throw('Server error');
  }
  // Observable navItem source
  private _authNavStatusSource = new BehaviorSubject<boolean>(false);
  // Observable navItem stream
  authNavStatus$ = this._authNavStatusSource.asObservable();

  private loggedIn = false;
  private userid = "_nodata_";
  private userlogin = "_nodata_";
  private username = "_nodata_";
  private role = "_nodata_";
  private clientId: number = 0;
  private firstAppLoad = false;

  constructor(
    private http: Http,
    private configService: ConfigService,
    private dataService: DataService,
    //private log_service: LogService
    ) {
    super();
    this.loggedIn = !!localStorage.getItem('auth_token');
    // ?? not sure if this the best way to broadcast the status but seems to resolve issue on page refresh where auth status is lost in
    // header component resulting in authed user nav links disappearing despite the fact user is still logged in
    this._authNavStatusSource.next(this.loggedIn);
    this.baseUrl = configService.getApiURI();
  }/*
  protected handleError(error: any) {
    this.log_service.error("webapp", "visualis.data.service.ts", "habdleError", error);
    return Observable.throw('Server error');
  }*/
  doFirstAppLoad() {
    let isFirst = this.firstAppLoad;
    this.firstAppLoad = false;
    return isFirst;
  }

  register(email: string, password: string, name: string, isadmin: string, clientId: string): Observable<UserRegistration> {
    let body = JSON.stringify({ email, password, name, isadmin, clientId });
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    return this.http.post(this.baseUrl + "/accounts", body, options)
      .map(res => true)
      .catch(this.handleError);
  }

  login(userName, password) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    return this.http
      .post(
        this.baseUrl + '/auth/login',
        JSON.stringify({ userName, password }), { headers }
      )
      .map(res => res.json())
      .map(res => {

        // Here we try to decode the JWT
        let tokenPayload = decode(res.auth_token);
        //console.log('Login Role : ', tokenPayload.visualisRole);
        localStorage.setItem('auth_token', res.auth_token);
        this.username = "_nodata_";
        this.userlogin = "_nodata_";
        this.userid = "_nodata_";
        this.loggedIn = true;
        this._authNavStatusSource.next(true);
        return true;
      })
      .catch(this.handleError);
  }

  getClientId() {
    let clientid = 0;
    if (this.isLoggedIn()) {
      clientid = this.clientId;
    }
    return clientid;
  }

  getUsername() {
    if (this.isLoggedIn()) {
      if (this.username == "_nodata_") {
        //console.log("UserService : Started GetUsername");
        let token = localStorage.getItem('auth_token');
        let tokenPayload = decode(token);
        //console.log("tokenpayload : ", tokenPayload);
        this.username = tokenPayload.username;
        this.userlogin = tokenPayload.userlogin;
        this.userid = tokenPayload.userid;
        this.clientId = tokenPayload.clientId;
        //this.obtainClient();
        //console.log("UserService : Done GetUsername");
      }
    }
    return this.username;
  }

  getUserlogin() {
    let aname = this.getUsername();
    return this.userlogin;
  }

  logout() {
    localStorage.removeItem('auth_token');
    document.cookie = 'credentials=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.tsgenviro.com';

    this.loggedIn = false;
    this.username = "_nodata_";
    this.role = "_nodata_";
    this._authNavStatusSource.next(false);
  }

  isLoggedIn() {
    //const token = localStorage.getItem('token');
    // Check whether the token is expired and return
    // true or false
    //console.log('IsLoggedIn Check : ', token, this.jwtHelper.isTokenExpired(token));

    return this.loggedIn;
  }

  isAdmin() {
    if (this.isLoggedIn()) {
      if (this.role == "_nodata_") {
        let token = localStorage.getItem('auth_token');
        let tokenPayload = decode(token);
        this.role = tokenPayload.visualisRole;
      }
      return (this.role == "admin");
    }
    else
      return false;
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/services/user.service.ts